import { Component, Input } from '@angular/core';
import { Log } from '../../models/log.model';
import { LogService } from '../../services/log.service';
import { generatePagination } from '../../utils/pagination.utils';

@Component({
  selector: 'app-user-logs',
  standalone: false,
  templateUrl: './user-logs.component.html',
  styleUrl: './user-logs.component.css'
})
export class UserLogsComponent {
  @Input() uuid!: string;
  logs: Log[] = [];
  nextPageUrl: string | null = null;
  previousPageUrl: string | null = null;
  currentPage = 1;
  totalPages = 1;
  pageNumbers: any = [];
  submitted = false;

  constructor(
    private logService: LogService
  ) {}

  ngOnInit() {
    this.loadLogs(this.currentPage);
  }

  reset() {
    this.logs = [];
    this.nextPageUrl = null;
    this.previousPageUrl = null;
    this.currentPage = 1;
    this.totalPages = 1;
    this.pageNumbers = [];
  }

  loadLogs(page: number) {
    this.reset();
    this.submitted = true;

    this.logService.getLogs(this.uuid, page).subscribe(
      response => {
        this.logs = response.results;
        this.nextPageUrl = response.next;
        this.previousPageUrl = response.previous;
        this.currentPage = page;

        const itemsPerPage = 20;
        this.totalPages = Math.ceil(response.count / itemsPerPage);
        this.pageNumbers = generatePagination(this.currentPage, this.totalPages);
        this.submitted = false;
      }
    );
  }

  goToNextPage() {
    if (this.nextPageUrl) {
      const nextPage = this.getPageNumber(this.nextPageUrl);
      this.loadLogs(nextPage);
    }
  }

  goToPreviousPage() {
    if (this.previousPageUrl) {
      const prevPage = this.getPageNumber(this.previousPageUrl);
      this.loadLogs(prevPage);
    }
  }

  private getPageNumber(url: string): number {
    if (!url) return 1; // fallback if url is null

    const queryString = url.split('?')[1]; // get everything after "?"
    if (!queryString) return 1;

    const params = new URLSearchParams(queryString);
    const page = params.get('page');

    return page ? Number(page) : 1;
  }
}
